module.exports = __webpack_public_path__ + "images/emoji/clock130.14de6d2a2c901ce14b53.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock130.png
// module id = szqk
// module chunks = 14